import React, { FC } from 'react';

interface Props {
  className?: string;
  size?: number;
  color?: string;
}

export const PunchInIcon: FC<Props> = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.998 16L15.998 12L10.998 8V11H1.99799V13H10.998V16Z" />
      <path d="M12.999 2.99906C11.8165 2.99578 10.6452 3.22717 9.55276 3.67982C8.46035 4.13247 7.46861 4.79739 6.63501 5.63606L8.04901 7.05006C9.37101 5.72806 11.129 4.99906 12.999 4.99906C14.869 4.99906 16.627 5.72806 17.949 7.05006C19.271 8.37206 20 10.1301 20 12.0001C20 13.8701 19.271 15.6281 17.949 16.9501C16.627 18.2721 14.869 19.0011 12.999 19.0011C11.129 19.0011 9.37101 18.2721 8.04901 16.9501L6.63501 18.3641C8.33401 20.0641 10.594 21.0011 12.999 21.0011C15.404 21.0011 17.664 20.0641 19.363 18.3641C21.063 16.6651 22 14.4051 22 12.0001C22 9.59506 21.063 7.33506 19.363 5.63606C18.5294 4.79739 17.5377 4.13247 16.4453 3.67982C15.3529 3.22717 14.1815 2.99578 12.999 2.99906Z" />
    </svg>
  );
};
